import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/navbar/Navbar.js';
import Footer from '../components/Footer.js';
import { useSEO } from '../components/CustomHook';

const NotFound = () => {
    // SEO-Optimierung für die 404-Seite
    useSEO(
        "Seite nicht gefunden - Schmid Energieberatung | 404 Error",
        "Die gesuchte Seite wurde nicht gefunden. Zurück zur Startseite von Schmid Energieberatung - Ihr Experte für erneuerbare Energien.",
        "404, Seite nicht gefunden, Schmid Energieberatung, Energieberatung",
        "/logo512.png"
    );

    return (
        <>
            <Navbar />
            <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-md w-full space-y-8">
                    <div className="text-center">
                        <h1 className="text-9xl font-bold text-gray-300">404</h1>
                        <h2 className="mt-6 text-3xl font-extrabold text-gray-900">
                            Seite nicht gefunden
                        </h2>
                        <p className="mt-2 text-sm text-gray-600">
                            Die gesuchte Seite existiert leider nicht oder wurde verschoben.
                        </p>
                        <div className="mt-6">
                            <Link
                                to="/"
                                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                            >
                                Zurück zur Startseite
                            </Link>
                        </div>
                        <div className="mt-8">
                            <h3 className="text-lg font-medium text-gray-900 mb-4">
                                Beliebte Seiten:
                            </h3>
                            <div className="space-y-2">
                                <Link
                                    to="/solaranlage-schritte"
                                    className="block text-primary"
                                >
                                    → In 5 Schritten zur Solaranlage
                                </Link>
                                <Link
                                    to="/kontakt"
                                    className="block text-primary"
                                >
                                    → Kontakt
                                </Link>
                                <Link
                                    to="/foerderrechner-waermepumpe"
                                    className="block text-primary"
                                >
                                    → Förderrechner Wärmepumpe
                                </Link>
                                <Link
                                    to="/sanierungsfahrplan"
                                    className="block text-primary"
                                >
                                    → Sanierungsfahrplan
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default NotFound; 